exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".DraftList-8b71a3e5{font-family:\"aktiv-grotesk\",\"Aktiv Grotesk\",\"Open Sans\",\"Gill Sans MT\",\"Gill Sans\",Corbel,Arial,sans-serif;font-size:14px}.pageTitleOverride-26b1b3c7{margin-bottom:10px}.draftTitle-14efcf8d{font-family:\"futura-pt\",\"Futura PT\",\"Open Sans\",\"Gill Sans MT\",\"Gill Sans\",Corbel,Arial,sans-serif;margin:30px 0 0 0}.draftTitle-14efcf8d a{color:inherit;text-decoration:none}.draftMeta-f72107ed{margin:10px 0}a.viewLink-990529a8,a.editLink-fcb4ae1d,a.restoreLink-4c8cde3f{color:#666;text-decoration:none;cursor:pointer}a.deleteLink-b09aece0{color:#b71c1c;text-decoration:none;cursor:pointer}.spinner-7ef7d0a1{margin:30px 0}.hint-e8055a25{font-style:italic;margin:20px 0;color:#666}\n", ""]);

// Exports
exports.locals = {
	"DraftList": "DraftList-8b71a3e5",
	"pageTitleOverride": "pageTitleOverride-26b1b3c7",
	"draftTitle": "draftTitle-14efcf8d",
	"draftMeta": "draftMeta-f72107ed",
	"viewLink": "viewLink-990529a8",
	"editLink": "editLink-fcb4ae1d",
	"restoreLink": "restoreLink-4c8cde3f",
	"deleteLink": "deleteLink-b09aece0",
	"spinner": "spinner-7ef7d0a1",
	"hint": "hint-e8055a25"
};